import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _CheckmarkCircle, _span;
import { useEffect, useReducer, useState } from "react";
import { useApolloClient, useMutation, useQuery } from "@apollo/client";
import { getSourceEventParams, useAmplitude } from "@crehana/analytics";
import { useMe } from "@crehana/auth";
import CheckmarkCircle from "@crehana/icons/fill/CheckmarkCircle";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Dialog } from "@crehana/ui";
import BasicDataForm from "../../auth/components/BasicDataForm";
import ShoppingCartPopup from "../../components/ShoppingCartPopup";
import { useUITheme } from "../../Layouts";
import Media from "../../Media";
import { initialState, ProductsContext } from "./context";
import { SNACKBAR_ACTIONS, snackbarReducer } from "./SnackBarConfirmation/reducers";
import SnackBarConfirmation from "./SnackBarConfirmation/SnackBarConfirmation";
var CourseQuery = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "ProductsCourseData"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "id"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      },
      directives: []
    }],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "course"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "id"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "id"
            }
          }
        }],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "originalId"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "title"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "price"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "currencySymbol"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "catalogCategories"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "name"
                },
                arguments: [],
                directives: []
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "catalogSubCategories"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "name"
                },
                arguments: [],
                directives: []
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 213,
    source: {
      body: "query ProductsCourseData($id: String!) {\n  course(id: $id) {\n    id\n    originalId\n    title\n    price\n    currencySymbol\n    catalogCategories {\n      name\n    }\n    catalogSubCategories {\n      name\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
};
var MyCartQuery = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "MyCart"
    },
    variableDefinitions: [],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "myCart"
        },
        arguments: [],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "user"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "originalId"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "isPremiumMember"
                },
                arguments: [],
                directives: []
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "originalId"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "realTotalPrice"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "totalDiscount"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "nextDiscount"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "dataExtraDiscount"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "type"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "percent"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "total"
                },
                arguments: [],
                directives: []
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "currencySymbol"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "price"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "prices"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currencySymbol"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "price"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "realPrice"
                },
                arguments: [],
                directives: []
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "pricesWithCredit"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "credit"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "priceWithCredit"
                },
                arguments: [],
                directives: []
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "isPaid"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "shoppingCartDetailCoursesSet"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "edges"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "node"
                    },
                    arguments: [],
                    directives: [],
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "discount"
                        },
                        arguments: [],
                        directives: []
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "prices"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "currencySymbol"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "price"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "realPrice"
                            },
                            arguments: [],
                            directives: []
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "course"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "originalId"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "title"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "urlToBuyNow"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "coverImage"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "imagePlaceholder"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "promoImage"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "professor"
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "fullName"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "occupation"
                                },
                                arguments: [],
                                directives: []
                              }]
                            }
                          }, {
                            kind: "Field",
                            alias: {
                              kind: "Name",
                              value: "priceInDollars"
                            },
                            name: {
                              kind: "Name",
                              value: "price"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            alias: {
                              kind: "Name",
                              value: "realPriceInDollars"
                            },
                            name: {
                              kind: "Name",
                              value: "realPrice"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "prices"
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "currencySymbol"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "price"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "realPrice"
                                },
                                arguments: [],
                                directives: []
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "score"
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "average"
                                },
                                arguments: [],
                                directives: []
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "comments"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "duration"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "discount"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "url"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "categoryObj"
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "name"
                                },
                                arguments: [],
                                directives: []
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "subCategory"
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "name"
                                },
                                arguments: [],
                                directives: []
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "shoppingCartDetailBundlesSet"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "edges"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "node"
                    },
                    arguments: [],
                    directives: [],
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "bundle"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "id"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "originalId"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "title"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "coverImageUrl"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "imagePlaceholderUrl"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "prices"
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "price"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "totalPrice"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "currencySymbol"
                                },
                                arguments: [],
                                directives: []
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "duration"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "discount"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "url"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "professors"
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "id"
                                },
                                arguments: [],
                                directives: []
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "urlToBuyNow"
                            },
                            arguments: [],
                            directives: []
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 1791,
    source: {
      body: "query MyCart {\n  myCart {\n    id\n    user {\n      originalId\n      isPremiumMember\n    }\n    originalId\n    realTotalPrice\n    totalDiscount\n    nextDiscount\n    dataExtraDiscount {\n      type\n      id\n      percent\n      total\n    }\n    currencySymbol\n    price\n    prices {\n      currencySymbol\n      price\n      realPrice\n    }\n    pricesWithCredit {\n      credit\n      priceWithCredit\n    }\n    isPaid\n    shoppingCartDetailCoursesSet {\n      edges {\n        node {\n          discount\n          prices {\n            currencySymbol\n            price\n            realPrice\n          }\n          course {\n            originalId\n            title\n            urlToBuyNow\n            coverImage\n            imagePlaceholder\n            promoImage\n            professor {\n              fullName\n              occupation\n            }\n            priceInDollars: price\n            realPriceInDollars: realPrice\n            prices {\n              currencySymbol\n              price\n              realPrice\n            }\n            score {\n              average\n            }\n            comments\n            duration\n            discount\n            url\n            categoryObj {\n              name\n            }\n            subCategory {\n              name\n            }\n          }\n        }\n      }\n    }\n    shoppingCartDetailBundlesSet {\n      edges {\n        node {\n          bundle {\n            id\n            originalId\n            title\n            coverImageUrl\n            imagePlaceholderUrl\n            prices {\n              price\n              totalPrice\n              currencySymbol\n            }\n            duration\n            discount\n            url\n            professors {\n              id\n            }\n            urlToBuyNow\n          }\n        }\n      }\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
};
/* shoppingCart graphql */
var ShoppingCartRemoveItem = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "shoppingCartRemoveItem"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "courseId"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "ID"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "bundleId"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "ID"
        }
      },
      directives: []
    }],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "shoppingCartRemoveItem"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "ObjectValue",
            fields: [{
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "courseId"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "courseId"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "bundleId"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "bundleId"
                }
              }
            }]
          }
        }],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "success"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "shoppingCart"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "user"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "originalId"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "isPremiumMember"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "originalId"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "realTotalPrice"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "totalDiscount"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "nextDiscount"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "dataExtraDiscount"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "type"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "percent"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "total"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currencySymbol"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "price"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "prices"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "currencySymbol"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "price"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "realPrice"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "pricesWithCredit"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "credit"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "priceWithCredit"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "isPaid"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "shoppingCartDetailCoursesSet"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "edges"
                    },
                    arguments: [],
                    directives: [],
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "node"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "discount"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "prices"
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "currencySymbol"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "price"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "realPrice"
                                },
                                arguments: [],
                                directives: []
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "course"
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "originalId"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "title"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "coverImage"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "promoImage"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "professor"
                                },
                                arguments: [],
                                directives: [],
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "fullName"
                                    },
                                    arguments: [],
                                    directives: []
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "occupation"
                                    },
                                    arguments: [],
                                    directives: []
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "prices"
                                },
                                arguments: [],
                                directives: [],
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "currencySymbol"
                                    },
                                    arguments: [],
                                    directives: []
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "price"
                                    },
                                    arguments: [],
                                    directives: []
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "realPrice"
                                    },
                                    arguments: [],
                                    directives: []
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "score"
                                },
                                arguments: [],
                                directives: [],
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "average"
                                    },
                                    arguments: [],
                                    directives: []
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "comments"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "duration"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "discount"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "url"
                                },
                                arguments: [],
                                directives: []
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "shoppingCartDetailBundlesSet"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "edges"
                    },
                    arguments: [],
                    directives: [],
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "node"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "bundle"
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "id"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "originalId"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "title"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "coverImageUrl"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "prices"
                                },
                                arguments: [],
                                directives: [],
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "price"
                                    },
                                    arguments: [],
                                    directives: []
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "totalPrice"
                                    },
                                    arguments: [],
                                    directives: []
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "currencySymbol"
                                    },
                                    arguments: [],
                                    directives: []
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "duration"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "discount"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "url"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "professors"
                                },
                                arguments: [],
                                directives: [],
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "urlToBuyNow"
                                },
                                arguments: [],
                                directives: []
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 1837,
    source: {
      body: "mutation shoppingCartRemoveItem($courseId: ID, $bundleId: ID) {\n  shoppingCartRemoveItem(input: { courseId: $courseId, bundleId: $bundleId }) {\n    success\n    shoppingCart {\n      id\n      user {\n        originalId\n        isPremiumMember\n      }\n      originalId\n      realTotalPrice\n      totalDiscount\n      nextDiscount\n      dataExtraDiscount {\n        type\n        id\n        percent\n        total\n      }\n      currencySymbol\n      price\n      prices {\n        currencySymbol\n        price\n        realPrice\n      }\n      pricesWithCredit {\n        credit\n        priceWithCredit\n      }\n      isPaid\n      shoppingCartDetailCoursesSet {\n        edges {\n          node {\n            discount\n            prices {\n              currencySymbol\n              price\n              realPrice\n            }\n            course {\n              originalId\n              title\n              coverImage\n              promoImage\n              professor {\n                fullName\n                occupation\n              }\n              prices {\n                currencySymbol\n                price\n                realPrice\n              }\n              score {\n                average\n              }\n              comments\n              duration\n              discount\n              url\n            }\n          }\n        }\n      }\n      shoppingCartDetailBundlesSet {\n        edges {\n          node {\n            bundle {\n              id\n              originalId\n              title\n              coverImageUrl\n              prices {\n                price\n                totalPrice\n                currencySymbol\n              }\n              duration\n              discount\n              url\n              professors {\n                id\n              }\n              urlToBuyNow\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
};
var ShoppingCartAddItem = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "shoppingCartAddItem"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "courseId"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "ID"
        }
      },
      directives: []
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "bundleId"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "ID"
        }
      },
      directives: []
    }],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "shoppingCartAddItem"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "ObjectValue",
            fields: [{
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "courseId"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "courseId"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "bundleId"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "bundleId"
                }
              }
            }]
          }
        }],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "success"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "shoppingCart"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "user"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "originalId"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "isPremiumMember"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "originalId"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "realTotalPrice"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "totalDiscount"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "nextDiscount"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "dataExtraDiscount"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "type"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "percent"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "total"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currencySymbol"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "price"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "prices"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "currencySymbol"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "price"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "realPrice"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "pricesWithCredit"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "credit"
                    },
                    arguments: [],
                    directives: []
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "priceWithCredit"
                    },
                    arguments: [],
                    directives: []
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "isPaid"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "shoppingCartDetailCoursesSet"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "edges"
                    },
                    arguments: [],
                    directives: [],
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "node"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "discount"
                            },
                            arguments: [],
                            directives: []
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "prices"
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "currencySymbol"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "price"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "realPrice"
                                },
                                arguments: [],
                                directives: []
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "course"
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "originalId"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "title"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "urlToBuyNow"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "coverImage"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "promoImage"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "professor"
                                },
                                arguments: [],
                                directives: [],
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "fullName"
                                    },
                                    arguments: [],
                                    directives: []
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "occupation"
                                    },
                                    arguments: [],
                                    directives: []
                                  }]
                                }
                              }, {
                                kind: "Field",
                                alias: {
                                  kind: "Name",
                                  value: "priceInDollars"
                                },
                                name: {
                                  kind: "Name",
                                  value: "price"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                alias: {
                                  kind: "Name",
                                  value: "realPriceInDollars"
                                },
                                name: {
                                  kind: "Name",
                                  value: "realPrice"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "prices"
                                },
                                arguments: [],
                                directives: [],
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "currencySymbol"
                                    },
                                    arguments: [],
                                    directives: []
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "price"
                                    },
                                    arguments: [],
                                    directives: []
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "realPrice"
                                    },
                                    arguments: [],
                                    directives: []
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "score"
                                },
                                arguments: [],
                                directives: [],
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "average"
                                    },
                                    arguments: [],
                                    directives: []
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "subCategory"
                                },
                                arguments: [],
                                directives: [],
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "name"
                                    },
                                    arguments: [],
                                    directives: []
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "categoryObj"
                                },
                                arguments: [],
                                directives: [],
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "name"
                                    },
                                    arguments: [],
                                    directives: []
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "enrollments"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "comments"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "duration"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "discount"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "url"
                                },
                                arguments: [],
                                directives: []
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "shoppingCartDetailBundlesSet"
                },
                arguments: [],
                directives: [],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "edges"
                    },
                    arguments: [],
                    directives: [],
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "node"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "bundle"
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "id"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "originalId"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "title"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "coverImageUrl"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "prices"
                                },
                                arguments: [],
                                directives: [],
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "price"
                                    },
                                    arguments: [],
                                    directives: []
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "totalPrice"
                                    },
                                    arguments: [],
                                    directives: []
                                  }, {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "currencySymbol"
                                    },
                                    arguments: [],
                                    directives: []
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "duration"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "discount"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "url"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "professors"
                                },
                                arguments: [],
                                directives: [],
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                  }]
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "urlToBuyNow"
                                },
                                arguments: [],
                                directives: []
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "enrollments"
                                },
                                arguments: [],
                                directives: []
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 2119,
    source: {
      body: "mutation shoppingCartAddItem($courseId: ID, $bundleId: ID) {\n  shoppingCartAddItem(input: { courseId: $courseId, bundleId: $bundleId }) {\n    success\n    shoppingCart {\n      id\n      user {\n        originalId\n        isPremiumMember\n      }\n      originalId\n      realTotalPrice\n      totalDiscount\n      nextDiscount\n      dataExtraDiscount {\n        type\n        id\n        percent\n        total\n      }\n      currencySymbol\n      price\n      prices {\n        currencySymbol\n        price\n        realPrice\n      }\n      pricesWithCredit {\n        credit\n        priceWithCredit\n      }\n      isPaid\n      shoppingCartDetailCoursesSet {\n        edges {\n          node {\n            discount\n            prices {\n              currencySymbol\n              price\n              realPrice\n            }\n            course {\n              originalId\n              title\n              urlToBuyNow\n              coverImage\n              promoImage\n              professor {\n                fullName\n                occupation\n              }\n              priceInDollars: price\n              realPriceInDollars: realPrice\n              prices {\n                currencySymbol\n                price\n                realPrice\n              }\n              score {\n                average\n              }\n              subCategory {\n                name\n              }\n              categoryObj {\n                name\n              }\n              enrollments\n              comments\n              duration\n              discount\n              url\n            }\n          }\n        }\n      }\n      shoppingCartDetailBundlesSet {\n        edges {\n          node {\n            bundle {\n              id\n              originalId\n              title\n              coverImageUrl\n              prices {\n                price\n                totalPrice\n                currencySymbol\n              }\n              duration\n              discount\n              url\n              professors {\n                id\n              }\n              urlToBuyNow\n              enrollments\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
};
/* Shoppingcart dependencies */
import { parseData } from "./shoppingCart/helpers";
import logger from "./shoppingCart/logger";
import { SHOPPING_CART_ACTIONS, shoppingCartReducer } from "./shoppingCart/reducers";
import { googleAnalyticsShoppingCart } from "./utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var mainReducer = function mainReducer(_ref,
// @ts-ignore
action) {
  var shoppingCartState = _ref.shoppingCartState,
    SnackbarState = _ref.SnackbarState;
  return {
    shoppingCartState: shoppingCartReducer(shoppingCartState, action),
    SnackbarState: snackbarReducer(SnackbarState, action)
  };
};
var ProductsContainer = function ProductsContainer(_ref2) {
  var flagClassicShoppingCart = _ref2.flagClassicShoppingCart,
    darkModeSupported = _ref2.darkModeSupported,
    children = _ref2.children,
    myCartQueryOptions = _ref2.myCartQueryOptions;
  var _useState = useState('BottomSheet'),
    _useState2 = _slicedToArray(_useState, 2),
    shoppingCartView = _useState2[0],
    setShoppingCartView = _useState2[1];
  var _useMe = useMe(),
    me = _useMe.me,
    loadingMeQuery = _useMe.loading;
  var client = useApolloClient();
  var _useQuery = useQuery(MyCartQuery, _objectSpread({
      fetchPolicy: 'network-only',
      skip: loadingMeQuery && !(me !== null && me !== void 0 && me.isPremiumMember)
    }, myCartQueryOptions)),
    myCartData = _useQuery.data,
    loadingMyCart = _useQuery.loading;
  var _useMutation = useMutation(ShoppingCartAddItem),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    shoppingCartAddItem = _useMutation2[0];
  var _useMutation3 = useMutation(ShoppingCartRemoveItem),
    _useMutation4 = _slicedToArray(_useMutation3, 1),
    shoppingCartRemoveItem = _useMutation4[0];
  var _useState3 = useState({
      isOpen: false,
      redirectUrl: null,
      requiredPhoneNumber: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    basicDataForm = _useState4[0],
    setBasicDataForm = _useState4[1];
  var _useReducer = useReducer(mainReducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _useReducer2$ = _useReducer2[0],
    shoppingCartState = _useReducer2$.shoppingCartState,
    SnackbarState = _useReducer2$.SnackbarState,
    dispatch = _useReducer2[1];
  var _useUITheme = useUITheme(),
    isDark = _useUITheme.isDark;
  var isDarkMode = isDark && darkModeSupported;
  var _useAmplitude = useAmplitude(),
    logEvent = _useAmplitude.logEvent;
  useEffect(function () {
    if (loadingMyCart) {
      dispatch({
        type: SHOPPING_CART_ACTIONS.SET_FLAG_CLASSIC_SHOPPING_CART,
        status: Boolean(flagClassicShoppingCart)
      });
      dispatch({
        type: SHOPPING_CART_ACTIONS.SET_LOADING_CART,
        status: true
      });
    } else {
      dispatch({
        type: SHOPPING_CART_ACTIONS.SET_LOADING_CART,
        status: false
      });
      if (myCartData !== null && myCartData !== void 0 && myCartData.myCart) {
        var data = parseData(myCartData.myCart);
        dispatch({
          type: SHOPPING_CART_ACTIONS.SET_STATE,
          state: data
        });
      }
    }
  }, [loadingMyCart, myCartData, flagClassicShoppingCart]);

  /** ********************************** */
  /** ***** Shoppingcart methods ******* */
  /** ********************************** */

  var addItemToFacebookTracker = function addItemToFacebookTracker(item) {
    var _item$catalogCategori, _item$catalogCategori2, _item$catalogSubCateg, _item$catalogSubCateg2;
    var facebookData = {
      content_name: item.title,
      content_category: "".concat((_item$catalogCategori = item.catalogCategories) === null || _item$catalogCategori === void 0 ? void 0 : (_item$catalogCategori2 = _item$catalogCategori[0]) === null || _item$catalogCategori2 === void 0 ? void 0 : _item$catalogCategori2.name, " > ").concat((_item$catalogSubCateg = item.catalogSubCategories) === null || _item$catalogSubCateg === void 0 ? void 0 : (_item$catalogSubCateg2 = _item$catalogSubCateg[0]) === null || _item$catalogSubCateg2 === void 0 ? void 0 : _item$catalogSubCateg2.name),
      content_ids: [item.originalId],
      content_type: 'product',
      order_item_type: 'course',
      value: item.price,
      currency: 'USD'
    };

    // @ts-expect-error
    if (typeof window !== 'undefined' && window.fbq) {
      // @ts-expect-error
      window.fbq('track', 'AddToCart', facebookData);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var removeItemMutation = function removeItemMutation(item) {
    var courseId = item.courseId,
      bundleId = item.bundleId;
    dispatch({
      type: SHOPPING_CART_ACTIONS.SET_LOADING_CART_MUTATION,
      status: true
    });
    var isCourse = !!courseId;
    dispatch({
      type: SNACKBAR_ACTIONS.SET_MESSAGE,
      message: "".concat(isCourse ? 'Curso eliminado' : 'Certificación eliminada', " del carrito.")
    });

    // @ts-ignore
    googleAnalyticsShoppingCart(courseId, bundleId, 'remove');
    return new Promise(function (resolve, reject) {
      shoppingCartRemoveItem({
        variables: {
          bundleId: bundleId,
          courseId: courseId
        }
      }).then(function (_ref3) {
        var _ref3$data$shoppingCa = _ref3.data.shoppingCartRemoveItem,
          success = _ref3$data$shoppingCa.success,
          shoppingCart = _ref3$data$shoppingCa.shoppingCart;
        dispatch({
          type: SHOPPING_CART_ACTIONS.SET_LOADING_CART_MUTATION,
          status: false
        });
        if (success) {
          var data = parseData(shoppingCart);
          dispatch({
            type: SHOPPING_CART_ACTIONS.SET_STATE,
            state: _objectSpread({}, data)
          });
          dispatch({
            type: SNACKBAR_ACTIONS.SHOW,
            open: true
          });
          resolve(shoppingCartState);
        } else {
          logger.warn('ShoppingCartRemoveItem mutation failed. Probably the item is not in the cart');
          reject(shoppingCartState);
        }
      })["catch"](function (err) {
        dispatch({
          type: SHOPPING_CART_ACTIONS.SET_LOADING_CART_MUTATION,
          status: false
        });
        console.error('error to remove item', err);
        reject(shoppingCartState);
      });
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var removeCourseFromCart = function removeCourseFromCart(course) {
    return (
      // @ts-ignore
      removeItemMutation(course)
    );
  };
  var addItemMutation = function addItemMutation(item) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      preventRedirect: false
    };
    var courseId = item.courseId,
      bundleId = item.bundleId;
    var preventRedirect = options.preventRedirect;
    var isMobile = window && window.innerWidth < 768;
    var SHOPPING_CART_URL = '/carrito-de-compras/';

    // @ts-ignore
    googleAnalyticsShoppingCart(courseId, bundleId, 'add');
    return new Promise(function (resolve, reject) {
      dispatch({
        type: SHOPPING_CART_ACTIONS.SET_LOADING_CART_MUTATION,
        status: true
      });
      dispatch({
        type: SHOPPING_CART_ACTIONS.SET_SHOW_SHOPPING_CART_POPUP,
        visibility: window.location.pathname !== SHOPPING_CART_URL
      });
      dispatch({
        type: SHOPPING_CART_ACTIONS.SET_FETCH_SHOPPING_CART_POPUP_CHUNK,
        visibility: window.location.pathname !== SHOPPING_CART_URL
      });
      shoppingCartAddItem({
        variables: {
          courseId: courseId,
          bundleId: bundleId
        }
      }).then(function (_ref4) {
        var _ref4$data$shoppingCa = _ref4.data.shoppingCartAddItem,
          success = _ref4$data$shoppingCa.success,
          shoppingCart = _ref4$data$shoppingCa.shoppingCart;
        if (success) {
          // @ts-expect-error
          if (typeof window !== 'undefined' && window.fbq && courseId) {
            client.query({
              query: CourseQuery,
              variables: {
                id: courseId
              }
            }).then(function (response) {
              if (response.data.course) {
                addItemToFacebookTracker(response.data.course);
                if (isMobile && !preventRedirect) {
                  setTimeout(function () {
                    window.location.href = SHOPPING_CART_URL;
                  }, 0);
                }
              }
            });
          }
          var data = parseData(shoppingCart);
          dispatch({
            type: SHOPPING_CART_ACTIONS.SET_LAST_ITEM_ADDED,
            item: courseId ? data.courses.find(function (course) {
              return course.originalId === courseId;
            }) : bundleId ? data.bundles.find(function (bundle) {
              return bundle.originalId === bundleId;
            }) : null
          });
          dispatch({
            type: SHOPPING_CART_ACTIONS.SET_LOADING_CART_MUTATION,
            status: false
          });
          dispatch({
            type: SHOPPING_CART_ACTIONS.SET_STATE,
            state: data
          });
          if (window.location.pathname === SHOPPING_CART_URL) {
            window.scroll(0, 0);
          }
          resolve(shoppingCartState);
        } else {
          dispatch({
            type: SHOPPING_CART_ACTIONS.SET_LOADING_CART_MUTATION,
            status: false
          });
          reject(success);
          logger.warn('shoppingCartAddItem mutation failed. Probably the item is already in the cart');
        }
      })["catch"](function (err) {
        dispatch({
          type: SHOPPING_CART_ACTIONS.SET_LOADING_CART_MUTATION,
          status: false
        });
        reject(err);
        console.error('error to add item', err);
      });
    });
  };
  var addCourseToCart = function addCourseToCart(course) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      preventRedirect: true
    };
    var courseId = course.courseId;
    dispatch({
      type: SHOPPING_CART_ACTIONS.SET_LAST_ITEM_ADDED_TYPE,
      itemType: 'course'
    });
    logEvent({
      event: 'Add to Shopping Cart',
      data: _objectSpread({
        'Item Type': 'course',
        'Item ID': courseId
      }, getSourceEventParams())
    });
    return addItemMutation(course, options);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var removeBundleFromCart = function removeBundleFromCart(bundle) {
    return (
      // @ts-ignore
      removeItemMutation(bundle)
    );
  };
  var closeShoppingCartPopup = function closeShoppingCartPopup() {
    dispatch({
      type: SHOPPING_CART_ACTIONS.SET_SHOW_SHOPPING_CART_POPUP,
      visibility: false
    });
    dispatch({
      type: SHOPPING_CART_ACTIONS.SET_LAST_ITEM_ADDED,
      item: null
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var addBundleToCart = function addBundleToCart(bundle) {
    dispatch({
      type: SHOPPING_CART_ACTIONS.SET_LAST_ITEM_ADDED_TYPE,
      itemType: 'bundle'
    });
    return addItemMutation(bundle);
  };
  useEffect(function () {
    if (SnackbarState.open) {
      setTimeout(function () {
        dispatch({
          type: SNACKBAR_ACTIONS.SHOW,
          open: false
        });
      }, 2500);
    }
  }, [SnackbarState.open]);
  var renderSnackBarConfimation = function renderSnackBarConfimation() {
    var open = SnackbarState.open,
      message = SnackbarState.message;
    return /*#__PURE__*/_jsx(Media, {
      from: "sm",
      children: /*#__PURE__*/_jsx(SnackBarConfirmation, {
        open: open,
        label: message,
        icon: _CheckmarkCircle || (_CheckmarkCircle = /*#__PURE__*/_jsx(CheckmarkCircle, {
          size: 16,
          ignoreColor: true,
          className: "fill-current text-green-main"
        }))
      })
    });
  };
  var renderShoppingCartDialog = function renderShoppingCartDialog() {
    var fetchShoppingCartPopupChunk = shoppingCartState.fetchShoppingCartPopupChunk,
      nextDiscount = shoppingCartState.nextDiscount;
    if (fetchShoppingCartPopupChunk) {
      return /*#__PURE__*/_jsx(Media, {
        from: "sm",
        children: function children(matches) {
          return /*#__PURE__*/_jsx(ShoppingCartPopup, {
            matches: matches,
            isShoppingcartLoading: shoppingCartState.loadingCartMutation,
            open: shoppingCartState.showShoppingCartPopup,
            onRequestClose: closeShoppingCartPopup,
            nextDiscount: nextDiscount,
            category: shoppingCartState.lastItemAdded && shoppingCartState.lastItemAdded.categoryName,
            subcategory: shoppingCartState.lastItemAdded && shoppingCartState.lastItemAdded.subcategoryName,
            isDarkMode: !!isDarkMode,
            shoppingCartView: shoppingCartView,
            setShoppingCartView: setShoppingCartView
          });
        }
      });
    }
    return _span || (_span = /*#__PURE__*/_jsx("span", {}));
  };
  var loadingCartMutation = shoppingCartState.loadingCartMutation;
  var showShoppingCartPopup = function showShoppingCartPopup() {
    var fetchShoppingCartPopupChunk = shoppingCartState.fetchShoppingCartPopupChunk;
    if (!fetchShoppingCartPopupChunk) {
      dispatch({
        type: SHOPPING_CART_ACTIONS.SET_FETCH_SHOPPING_CART_POPUP_CHUNK,
        visibility: true
      });
    }
    // This sets the the mobile shopping cart popup active, instead the resume view
    setShoppingCartView('ShoppingCartPopup');
    // This shows the shopping cart dialog
    dispatch({
      type: SHOPPING_CART_ACTIONS.SET_SHOW_SHOPPING_CART_POPUP,
      visibility: true
    });
  };
  return /*#__PURE__*/_jsxs(ProductsContext.Provider, {
    value: {
      shoppingCartState: shoppingCartState,
      /* Shoppingcart methods */
      loadingCartMutation: loadingCartMutation,
      addCourseToCart: addCourseToCart,
      removeCourseFromCart: removeCourseFromCart,
      addBundleToCart: addBundleToCart,
      removeBundleFromCart: removeBundleFromCart,
      closeShoppingCartPopup: closeShoppingCartPopup,
      showShoppingCartPopup: showShoppingCartPopup,
      // @ts-ignore
      setBasicDataForm: setBasicDataForm
    },
    children: [children, renderShoppingCartDialog(), renderSnackBarConfimation(), me && /*#__PURE__*/_jsx(Dialog, {
      open: basicDataForm.isOpen,
      size: "m",
      onDismiss: function onDismiss() {
        setBasicDataForm(_objectSpread(_objectSpread({}, basicDataForm), {}, {
          isOpen: false,
          redirectUrl: ''
        }));
      },
      children: /*#__PURE__*/_jsx("div", {
        className: "px-24 py-48 sm:px-48 md:px-96 lg:px-112",
        children: /*#__PURE__*/_jsx(BasicDataForm, {
          withInnerPadding: true,
          phoneNumberOptions: {
            isRequired: basicDataForm.requiredPhoneNumber
          },
          redirectUrl: basicDataForm.redirectUrl
        })
      })
    })]
  });
};
export default ProductsContainer;